import { useTranslation } from 'react-i18next'



function useTrialOptions() {
  const { t } = useTranslation()

  // 使用 i18n 时，不建议 enum 直接存储中文。可以用英文 key，显示时用 t() 翻译。
  enum Country {
    China = 'China',
    HongKongChina = 'HongKongChina',
    MacauChina = 'MacauChina',
    TaiwanChina = 'TaiwanChina',
    Japan = 'Japan',
    Korea = 'Korea',
    Mongolia = 'Mongolia',
    Singapore = 'Singapore',
    Thailand = 'Thailand',
    Vietnam = 'Vietnam',
    Malaysia = 'Malaysia',
    Philippines = 'Philippines',
    Indonesia = 'Indonesia',
    Cambodia = 'Cambodia',
    Laos = 'Laos',
    India = 'India',
    SaudiArabia = 'SaudiArabia',
    Turkey = 'Turkey',
    Israel = 'Israel',
    UnitedArabEmirates = 'UnitedArabEmirates',
    Qatar = 'Qatar',
    Kuwait = 'Kuwait',
    UnitedKingdom = 'UnitedKingdom',
    France = 'France',
    Germany = 'Germany',
    Netherlands = 'Netherlands',
    Belgium = 'Belgium',
    Austria = 'Austria',
    Italy = 'Italy',
    Spain = 'Spain',
    Portugal = 'Portugal',
    Greece = 'Greece',
    Sweden = 'Sweden',
    Norway = 'Norway',
    Finland = 'Finland',
    Denmark = 'Denmark',
    Estonia = 'Estonia',
    Latvia = 'Latvia',
    Russia = 'Russia',
    Poland = 'Poland',
    CzechRepublic = 'CzechRepublic',
    Hungary = 'Hungary',
    Romania = 'Romania',
    Bulgaria = 'Bulgaria',
    Slovakia = 'Slovakia',
    Slovenia = 'Slovenia',
    Ukraine = 'Ukraine',
    UnitedStates = 'UnitedStates',
    Canada = 'Canada',
    Mexico = 'Mexico',
    Brazil = 'Brazil',
    LatinAmerica = 'LatinAmerica',
    Australia = 'Australia',
    NewZealand = 'NewZealand',
    Other = 'Other',
  }

  enum Department {
    Brand = 'Brand',
    Market = 'Market',
    Marketing = 'Marketing',
    IT = 'IT',
    Procurement = 'Procurement',
    Other = 'Other',
  }

  enum Role {
    President = 'President',
    CMO = 'CMO',
    Director = 'Director',
    Manager = 'Manager',
    Other = 'Other',
  }

  const DEPARTMENT_OPTIONS = [
    { value: Department.Brand, label: t(`modals.freeTrialModal.department.${Department.Brand}`) },
    { value: Department.Market, label: t(`modals.freeTrialModal.department.${Department.Market}`) },
    { value: Department.Marketing, label: t(`modals.freeTrialModal.department.${Department.Marketing}`) },
    { value: Department.IT, label: t(`modals.freeTrialModal.department.${Department.IT}`) },
    { value: Department.Procurement, label: t(`modals.freeTrialModal.department.${Department.Procurement}`) },
    { value: Department.Other, label: t(`modals.freeTrialModal.department.${Department.Other}`) },
  ]

  const COUNTRY_OPTIONS = [
    { value: Country.China, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.China}`) },
    { value: Country.HongKongChina, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.HongKongChina}`) },
    { value: Country.MacauChina, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.MacauChina}`) },
    { value: Country.TaiwanChina, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.TaiwanChina}`) },
    { value: Country.Japan, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Japan}`) },
    { value: Country.Korea, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Korea}`) },
    { value: Country.Mongolia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Mongolia}`) },
    { value: Country.Singapore, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Singapore}`) },
    { value: Country.Thailand, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Thailand}`) },
    { value: Country.Vietnam, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Vietnam}`) },
    { value: Country.Malaysia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Malaysia}`) },
    { value: Country.Philippines, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Philippines}`) },
    { value: Country.Indonesia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Indonesia}`) },
    { value: Country.Cambodia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Cambodia}`) },
    { value: Country.Laos, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Laos}`) },
    { value: Country.India, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.India}`) },
    { value: Country.SaudiArabia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.SaudiArabia}`) },
    { value: Country.Turkey, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Turkey}`) },
    { value: Country.Israel, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Israel}`) },
    { value: Country.UnitedArabEmirates, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.UnitedArabEmirates}`) },
    { value: Country.Qatar, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Qatar}`) },
    { value: Country.Kuwait, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Kuwait}`) },
    { value: Country.UnitedKingdom, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.UnitedKingdom}`) },
    { value: Country.France, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.France}`) },
    { value: Country.Germany, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Germany}`) },
    { value: Country.Netherlands, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Netherlands}`) },
    { value: Country.Belgium, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Belgium}`) },
    { value: Country.Austria, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Austria}`) },
    { value: Country.Italy, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Italy}`) },
    { value: Country.Spain, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Spain}`) },
    { value: Country.Portugal, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Portugal}`) },
    { value: Country.Greece, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Greece}`) },
    { value: Country.Sweden, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Sweden}`) },
    { value: Country.Norway, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Norway}`) },
    { value: Country.Finland, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Finland}`) },
    { value: Country.Denmark, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Denmark}`) },
    { value: Country.Estonia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Estonia}`) },
    { value: Country.Latvia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Latvia}`) },
    { value: Country.Russia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Russia}`) },
    { value: Country.Poland, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Poland}`) },
    { value: Country.CzechRepublic, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.CzechRepublic}`) },
    { value: Country.Hungary, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Hungary}`) },
    { value: Country.Romania, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Romania}`) },
    { value: Country.Bulgaria, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Bulgaria}`) },
    { value: Country.Slovakia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Slovakia}`) },
    { value: Country.Slovenia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Slovenia}`) },
    { value: Country.Ukraine, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Ukraine}`) },
    { value: Country.UnitedStates, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.UnitedStates}`) },
    { value: Country.Canada, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Canada}`) },
    { value: Country.Mexico, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Mexico}`) },
    { value: Country.Brazil, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Brazil}`) },
    { value: Country.LatinAmerica, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.LatinAmerica}`) },
    { value: Country.Australia, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Australia}`) },
    { value: Country.NewZealand, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.NewZealand}`) },
    { value: Country.Other, label: t(`dashboard.projectCreatePage.targetMarketSelect.${Country.Other}`) },
  ]

  const ROLE_OPTIONS = [
    { value: Role.President, label: t(`modals.freeTrialModal.role.${Role.President}`) },
    { value: Role.CMO, label: t(`modals.freeTrialModal.role.${Role.CMO}`) },
    { value: Role.Director, label: t(`modals.freeTrialModal.role.${Role.Director}`) },
    { value: Role.Manager, label: t(`modals.freeTrialModal.role.${Role.Manager}`) },
    { value: Role.Other, label: t(`modals.freeTrialModal.role.${Role.Other}`) },
  ]

  return {
    CountryEnum: Country,
    DepartmentEnum: Department,
    RoleEnum: Role,
    DEPARTMENT_OPTIONS,
    COUNTRY_OPTIONS,
    ROLE_OPTIONS,
  }

}

export default useTrialOptions